import React, { useMemo, useState } from 'react';
import { Button, Input } from 'antd';
import axios from 'axios';
import { API_DOMAIN } from '../constants';
import useSnackbar from '../Snackbar/UseSnackbar';
import siteConfig from '../../siteConfig';

// Update this together with siteConfig.version/build_no before each rollout.
// It is only the text area's initial value, so the publisher can freely edit
// the release notes in Global Settings before broadcasting them.
const DEFAULT_CHANGELOG = `🚀 What's new in SRM v4.8.0

💬 Internal Team Chat
Private one-to-one conversations now support live messages, presence, replies, priorities, attachments, delivery/read receipts, unread alerts, and missed-message synchronization.

🖼️ Better Media Messaging
Drag and drop multiple files, see every upload immediately, send them sequentially, preview images, download attachments, and navigate conversations with date separators, new-message markers, and scroll-to-bottom controls.

🎯 Modernized Task Management
Refreshed lifecycle tabs and cards, purchase-order groups, animated part progress steppers, action controls, financial summaries, and the Handle Purchase experience.

📍 Reliable Customer Addresses
Customer addresses now use dedicated add, edit, and delete operations, with the shared customer drawer available consistently across Sales Pipeline, Customers, and Operations.

🔌 Resilient WhatsApp Connectivity
Customer and supplier live updates now use the authenticated SRM socket, with shared WATI relay health, accurate browser-outage indicators, automatic reconnection, and immediate chat and board recovery refreshes.

🔔 Smarter SRM Updates
Update announcements now include version and build details, detect missed releases after reconnect, and provide an editable prefilled changelog for administrators.

✨ Refinements & Fixes
Additional interface improvements and reliability fixes across Operations, Sales Pipeline, customer workflows, chat, and application navigation.`;

export function UpdateNotificationPanel() {
  const head = useMemo(() => ({ headers: { accessToken: localStorage.getItem("accessToken") } }), []);
  const { SuccessSnackbar, ErrorSnackbar } = useSnackbar();

  const [changelog, setChangelog] = useState(DEFAULT_CHANGELOG);
  const [pushing, setPushing] = useState(false);

  const handlePush = async () => {
    setPushing(true);
    try {
      const res = await axios.post(`${API_DOMAIN}/whatsapp/push_new_version_event`, {
        changelog,
        version: siteConfig.version,
        build_no: siteConfig.build_no,
        published_at: new Date().toISOString(),
      }, head);
      if (res.data.success) {
        SuccessSnackbar("Update notification pushed!");
        setChangelog(DEFAULT_CHANGELOG);
      } else {
        ErrorSnackbar(res.data.message);
      }
    } catch (error) {
      ErrorSnackbar(error.message);
    } finally {
      setPushing(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div>
        <div style={{ fontSize: 12, color: "#595959", marginBottom: 10 }}>
          Publishing <strong>SRM v{siteConfig.version}</strong> · build <strong>{siteConfig.build_no}</strong>
        </div>
        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>Changelog</div>
        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 8 }}>
          Description of the latest software update — shown to users in the update notification.
        </div>
        <Input.TextArea
          rows={8}
          value={changelog}
          onChange={e => setChangelog(e.target.value)}
          placeholder="What's new in this update…"
        />
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button type="primary" loading={pushing} disabled={!changelog.trim()} onClick={handlePush}>
          Push update notif
        </Button>
      </div>
    </div>
  );
}
